export default __webpack_public_path__ + "static/media/faseya_video.45ed9ea1.mp4";